export default __webpack_public_path__ + "static/media/user.ce965d36.svg";